import { render, staticRenderFns } from "./TextWithRightImage.vue?vue&type=template&id=7773800d&scoped=true&lang=pug&"
import script from "./TextWithRightImage.vue?vue&type=script&lang=js&"
export * from "./TextWithRightImage.vue?vue&type=script&lang=js&"
import style0 from "./TextWithRightImage.vue?vue&type=style&index=0&id=7773800d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7773800d",
  null
  
)

export default component.exports